export default __webpack_public_path__ + "static/media/event.4e6f82df.png";